import { createSlice } from '@reduxjs/toolkit';

const groupchatSlice = createSlice({
  name: 'groupchat',
  initialState: {
    groups: {},
  },
  reducers: {
    setGroupChat: (state, action) => {
      state.groups = action.payload; // Assuming you want to store the group data in 'groups'
    },
  },
});

export const { setGroupChat } = groupchatSlice.actions;
export default groupchatSlice.reducer;
